import { getTypeOrNull } from '@spotify/confidence-graphql';
import {
  UserMessage,
  createChatEventExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const UserMessageEventExtension = confidenceChatPlugin.provide(
  createChatEventExtension({
    id: 'user-message',
    predicate: event => Boolean(event.userMessage),
    render: event => {
      const message = event.userMessage;
      if (!message) return null;
      const hasContent = !!message.content;
      const hasParts = (message.parts ?? []).length > 0;
      if (!hasContent && !hasParts) return null;
      return (
        <UserMessage
          content={message.content}
          parts={message.parts}
          author={getTypeOrNull(event.creator)}
        />
      );
    },
  }),
);
